export * from "@/ui/components/sections/marketing/social-proof/Stars/Stars";
export * from "@/ui/components/sections/marketing/social-proof/Stars/Stars.config";
